
const bsn = require('bootstrap.native');

import { stringify, parse } from "qs";
const Pikaday = require('pikaday');
const { language_switch , pikaday_i18n_en , pikaday_i18n_af} = window.tg;
import dayjs from 'dayjs';

var customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)

import 'dayjs/locale/af';
import 'dayjs/locale/en';

if (language_switch === 'en') {
    dayjs.locale('en');
} else {
    dayjs.locale('af');
}

// import '../../../../../suppliers/assets/js/vendor/hammer.min.js';

"use strict";
// the semi-colon before function invocation is a safety net against concatenated
// scripts and/or other plugins which may not be closed properly.
;
(function ($, window, undefined) {

    // undefined is used here as the undefined global variable in ECMAScript 3 is
    // mutable (ie. it can be changed by someone else). undefined isn't really being
    // passed in so we can ensure the value of it is truly undefined. In ES5, undefined
    // can no longer be modified.

    // window and document are passed through as local variables rather than globals
    // as this (slightly) quickens the resolution process and can be more efficiently
    // minified (especially when both are regularly referenced in your plugin).
    let cell_width = 65;
    let info_div_width = 0;
    // Create the defaults once
    var pluginName = 'grid',
        document = window.document,
        defaults = {
            start_day: new Date().getDate(),
            start_month: new Date().getMonth(),
            start_year: new Date().getFullYear(),
            timespan: 0,
            granularity: 1,
            adult: 2,
            rates_lang: '',
            units: {},
            element_selector: '#grid',
            element_hack: 'grid',
        };

    // The actual plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this.styling = {};

        if (!(defaults.timespan > 0)) {
            var grid_width = $(options.element_selector).width();
            var cell_width = grid_width > 520 ? 80 : 65;
            var info_div_width = grid_width > 520 ? 150 : 0;
            defaults['timespan'] = Math.floor(($(options.element_selector).width() - info_div_width) / cell_width);
        }

        // jQuery has an extend method which merges the contents of two or
        // more objects, storing the result in the first object. The first object
        // is generally empty as we don't want to alter the default options for
        // future instances of the plugin
        this.options = $.extend({}, defaults, options);
        this.options.start_date = new Date();
        this.options.start_date.setDate(this.options.start_day);

        this.options.start_date.setMonth(this.options.start_month);
        this.options.start_date.setFullYear(this.options.start_year);

        this.options.end_date = new Date(this.options.start_date);
        this.options.end_date.setDate(this.options.end_date.getDate() + this.options.timespan - 1);

        this._defaults = defaults;
        this._name = pluginName;

        this._loaded_until = new Date();
        this._room_csv = [];
        for (var i = 0; i < this.options.units.length; i++) {
            this._room_csv.push(this.options.units[i].id);
        }
        this._room_csv = JSON.stringify(this._room_csv);

        var getPriceType = function(date, day_price_type) {
            var day_price_type = (day_price_type !== undefined && day_price_type);

            if (date !== undefined && day_price_type){
              if (this.prices[date.format("yyyy-mm-dd")] !== undefined){
                return this.prices[date.format("yyyy-mm-dd")].price_type;
              }
            }

            var key = Object.keys(this.prices)[0];
            if (key !== undefined) {
                return this.prices[key].price_type;
            } else {
                return "per_unit";
            }
        };

        var getCapacity = function () {
            var key = Object.keys(this.prices)[0];
            if (key !== undefined) {
                return this.prices[key].sleeps;
            } else {
                return 2;
            }
        };

        var getAvailability = function (date) {
            if (date.format("yyyy-mm-dd") in this.prices && this.prices[date.format("yyyy-mm-dd")].price == 0 && this.prices[date.format("yyyy-mm-dd")].price == undefined) {
                return 'not_loaded';
            } else {
                return (date.format("yyyy-mm-dd") in this.prices && this.prices[date.format("yyyy-mm-dd")].price !== 0 && this.prices[date.format("yyyy-mm-dd")].price !== undefined);
            }
        }

        var getPrice = function (date) {
            var price = this.adult == 1 ? "" + this.prices[date.format("yyyy-mm-dd")].single_price : "" + this.prices[date.format("yyyy-mm-dd")].price;

            if (this.flash_deal && this.flash_deal_until) {
                var flash_deal_until = Date.parse(this.flash_deal_until);
                if (new Date(flash_deal_until) > date) {
                    price += "<span class='star'>*</span>";
                }
            }
            return price;
        }

        var getPricePax = function (date, price_type = "per_person") {
            if (price_type == "per_person") {
                return this.prices[date.format("yyyy-mm-dd")].price_pax;
            }
            return this.prices[date.format("yyyy-mm-dd")].sleeps;
        }

        var getPricePriceBreakdownPax = function (date) {
            var price_breakdown_pax = this.prices[date.format("yyyy-mm-dd")].price_breakdown_pax;
            return price_breakdown_pax;
        }

        var getEstimate = function (date) {
            var estimate = this.prices[date.format("yyyy-mm-dd")].estimate;

            return estimate;
        }

        var getMinStay = function (date) {
            var minStay = this.prices[date.format("yyyy-mm-dd")].min_stay;

            return minStay;
        }

        for (var i = 0; i < this.options.units.length; i++) {
            this.options.units[i].prices = {};
            this.options.units[i].getPricePax = getPricePax;
            this.options.units[i].getPriceType = getPriceType;
            this.options.units[i].getCapacity = getCapacity;
            this.options.units[i].getAvailability = getAvailability;
            this.options.units[i].getPrice = getPrice;
            this.options.units[i].getPricePriceBreakdownPax = getPricePriceBreakdownPax;
            this.options.units[i].getEstimate = getEstimate;
            this.options.units[i].getMinStay = getMinStay;
        }

        // Language support
        var english_ordinal_suffix_of = function (i) {
            //http://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number
            var j = i % 10,
                k = i % 100;
            if (j == 1 && k != 11) {
                return i + "st";
            }
            if (j == 2 && k != 12) {
                return i + "nd";
            }
            if (j == 3 && k != 13) {
                return i + "rd";
            }
            return i + "th";
        };

        var afrikaans_ordinal_suffix_of = function (i) {
            //http://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number
            if (i >= 2 && i <= 19) {
                return i + "de";
            }
            return i + "ste";
        };


        var english = {
            ordinal: english_ordinal_suffix_of,
            months_short: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            days_short: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            full: "FULL",
            person: "Person",
            people: "People",
            person_small: "person",
            people_small: "people",
            for: "for",
            each: "Each",
            whole_unit: "Whole Unit",
            capacity: "Capacity",
            sleeps_up_to: "Sleeps up to",
            priceperunit: "Prices per unit",
            priceperpersonsharing: "Prices per night",
            priceperperson: "Prices per night",
            pernight: "per night",
            perperson: "per person",
            perunitsmall: "per unit",
            perpersonsmall: "pps.",
            children_rates: "Children's rates will be calculated when you make an enquiry.",
            single: "Single",
            sharing: "Sharing",
            child: "Child",
            sleeps: "sleeps",
            sleeps_cap: "Sleeps",
            min_stay: "Minimum stay of",
            day: "day.",
            days: "days.",
            mixed_rates: "Mixed Rates",
            check_in: "Check-in"
        }

        var afrikaans = {
            ordinal: afrikaans_ordinal_suffix_of,
            months_short: ["Jan", "Feb", "Mrt", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
            days_short: ['So', 'Mo', 'Di', 'Wo', 'Do', 'Vr', 'Sa'],
            full: "VOL",
            person: "Persoon",
            people: "Mense",
            person_small: "persoon",
            people_small: "mense",
            for: "vir",
            each: "Elk",
            whole_unit: "Hele Eenheid",
            capacity: "Kapasiteit",
            sleeps_up_to: "Slaapplek vir tot",
            priceperunit: "Pryse per eenh.",
            priceperpersonsharing: "Pryse per nag",
            priceperperson: "Pryse per nag",
            pernight: "per nag",
            perperson: "per persoon",
            perunitsmall: "per eenh.",
            perpersonsmall: "pps.",
            children_rates: "Kindertariewe sal bereken word wanneer u 'n navraag doen.",
            single: "Enkeltarief",
            sharing: "Gedeelde tarief",
            child: "Kindertarief",
            sleeps: "slaap",
            sleeps_cap: "Slaap",
            min_stay: "Minimum-verblyftydperk van",
            day: "dag.",
            days: "dae.",
            mixed_rates: "Mixed Rates",
            check_in: "Inklok"
        }

        this._language = language_switch === 'en' ? english : afrikaans;

        this.init();
    }

    Plugin.prototype.init = function () {
        // Add class for our CSS styling.
        $(this.element).addClass('grid position-relative text-select-none');

        var $obj = this;
        $obj.styling.width = $($obj.options.element_selector).width();

        cell_width = $obj.styling.width > 520 ? 80 : 65;
        info_div_width = $obj.styling.width > 520 ? 150 : 0;
        //defaults['timespan'] = Math.floor(($('#' + options.element_hack).width() - info_div_width) / cell_width);
        $obj.styling.cols_space = ($obj.styling.width - info_div_width) / (cell_width);
        $obj.styling.cols_num = (Math.floor($obj.styling.cols_space)) > 11 ? 11 : (Math.floor($obj.styling.cols_space));
        $obj.styling.padd_space = (($obj.styling.cols_space - $obj.styling.cols_num) * cell_width);
        $obj.styling.rates_width = $obj.styling.padd_space < cell_width ? (cell_width + ($obj.styling.padd_space / $obj.styling.cols_num)) + "px" : cell_width + "px";

        $obj.options.timespan = $obj.styling.cols_num;
        $obj.options.end_date = new Date($obj.options.start_date);
        $obj.options.end_date.setDate($obj.options.end_date.getDate() + $obj.options.timespan - 1);
        $obj.options.responsive_redraw = false;
        $obj.options.responsive_redraw = false;

        $(window).bind('load resize', function (e) {
            // Please be careful when adjusting - these values have been calculated throughly and even a slight variation might break things
            e.preventDefault();
            $obj.styling.width = $($obj.options.element_selector).width();

            cell_width = $obj.styling.width > 520 ? 80 : 65;
            info_div_width = $obj.styling.width > 520 ? 150 : 0;
            //defaults['timespan'] = Math.floor(($('#' + options.element_hack).width() - info_div_width) / cell_width);
            $obj.styling.cols_space = ($obj.styling.width - info_div_width) / (cell_width);
            $obj.styling.cols_num = (Math.floor($obj.styling.cols_space)) > 11 ? 11 : (Math.floor($obj.styling.cols_space));
            $obj.styling.padd_space = (($obj.styling.cols_space - $obj.styling.cols_num) * cell_width);
            $obj.styling.rates_width = $obj.styling.padd_space < cell_width ? (cell_width + ($obj.styling.padd_space / $obj.styling.cols_num)) + "px" : cell_width + "px";

            $obj.options.timespan = $obj.styling.cols_num;
            $obj.options.end_date = new Date($obj.options.start_date);
            $obj.options.end_date.setDate($obj.options.end_date.getDate() + $obj.options.timespan - 1);
            $obj.options.responsive_redraw = false;
            $obj.redraw();
        });

        // var that = this;

        // var element = document.getElementById('grid');

        // var hammertime = new Hammer(element, {

        // });
        // hammertime.on("swipeleft", function(event) {
        //     console.log("LEFT");
        //     $obj.next();
        // });

        // hammertime.on("swiperight", function(event) {
        //     console.log("RIGHT");
        //     $obj.previous();
        // });

        this.redraw();
    };

    Plugin.prototype.next = function () {
        const today = new Date();
        let granularity_next = this.options.granularity;

        // Hack to compensate for minus one date when date is same as today
        if (this.options.start_date.getDate() < today.getDate() ){
            granularity_next = 2;
        }

        this.options.start_date.setDate(this.options.start_date.getDate() + granularity_next);
        this.options.end_date.setDate(this.options.end_date.getDate() + granularity_next)
        this.redraw();
    };

    Plugin.prototype.previous = function () {
        this.options.start_date.setDate(this.options.start_date.getDate() - this.options.granularity);
        this.options.end_date.setDate(this.options.end_date.getDate() - this.options.granularity)
        this.redraw();
    };

    Plugin.prototype.redraw = function () {
        var $obj = this;

        // Call our preloader
        preloader(this, function () {
            $obj.redraw_();
        });
    };

    Plugin.prototype.redraw_ = function () {
        var $obj = this;
        var elementsPopoverList = document.querySelectorAll('.grid-available[data-room-id]'); // also a certain class would go fine
        elementsPopoverList.forEach(elementsPopover => {
            new bsn.default.Popover(elementsPopover, {}).dispose();
        })

        $(this.element).children(".grid-lines").remove();
        $(this.element).children(".grid-header").remove();

        var lines_div = $("<div></div>").addClass('grid-lines');

        $(this.element).append(create_header(this));
        $(this.element).append(lines_div);

        for (var i = 0; i < this.options.units.length; i++) {
            const unit = this.options.units[i]
            // Unit should not be shown in grid if it doesn't have rates set (value of either 0 or 999999)
            if (!(unit.prices.hasOwnProperty('noRates') && unit.prices.noRates === true)) {
                var line_div = redraw_line(this, unit);
                lines_div.append(line_div);
            }
        }

        elementsPopoverList = document.querySelectorAll('.grid-available[data-room-id]'); // also a certain class would go fine

        // attach a popover for each
        elementsPopoverList.forEach(elementsPopover => {
            const roomName = elementsPopover.getAttribute('data-room-name');
            const roomId = elementsPopover.getAttribute('data-room-id');
            const roomSleeps = elementsPopover.getAttribute('data-room-sleeps');
            const roomType = elementsPopover.getAttribute('data-room-type');
            let roomPriceBreakdownPax = elementsPopover.getAttribute('data-room-price-breakdown-pax');

            if (roomName && roomId && roomType && roomPriceBreakdownPax && roomSleeps) {
                let minStay = parseInt(elementsPopover.getAttribute('data-room-min-stay'));

                // Convert stringyfy array to object
                roomPriceBreakdownPax = parse(roomPriceBreakdownPax);

                var template = '<table style="width: 100%">';

                if (roomType === "per_unit") {
                    var text = $obj._language.whole_unit;
                    var price = "R" + roomPriceBreakdownPax[0];
                    template += "<tr><td>" + text + "</td><td>" + price + "</td></tr>";
                    template += "<tr><td>" + $obj._language.capacity + "</td><td>" + roomSleeps + " " + $obj._language.people + "</td></tr>";

                } else {
                    Object.keys(roomPriceBreakdownPax).forEach((item, index) => {
                        if (index === 0) {
                            var text = "1 " + $obj._language.person;
                            var price = "R" + roomPriceBreakdownPax[item];
                        } else {
                            var text = (index + 1) + " " + $obj._language.people;
                            var price = "R" + roomPriceBreakdownPax[item] + " " + $obj._language.each;
                        }

                        template += "<tr><td>" + text + "</td><td>" + price + "</td></tr>";
                    })
                }

                template += "</table>";

                if (minStay > 0 && minStay !== null) {
                    var day_s = minStay == 1 ? $obj._language.day : $obj._language.days;
                    template += "<div class='font-size-xs mt-2'>" + $obj._language.min_stay + " " + minStay + " " + day_s + "</div>";
                }

                template += "<div class='font-size-xs mt-2'>" + $obj._language.children_rates + "</div>";

                new bsn.default.Popover(elementsPopover, {
                    placement: 'bottom', //string
                    delay: 0, // integer
                    dismissible: false, // boolean
                    title: roomName,
                    content: template
                })
            }
        });

        /**
         *
         * Date picker
         *
         */
        var pikadayInput = document.getElementById('picker-date-' + $obj.options.element_hack);

        if (pikadayInput != null) {
            new Pikaday({
                i18n: /** @type {import("pikaday").PikadayI18nConfig} */  (language_switch == 'af' ? pikaday_i18n_af : pikaday_i18n_en),
                theme: 'theme-kd',
                field: pikadayInput,
                trigger: pikadayInput,
                format: 'D MMM YYYY',
                firstDay: 1,
                position: 'bottom left',
                container: document.getElementById($obj.options.element_hack + '-container'),
                reposition: false,
                minDate: dayjs().toDate(),
                defaultDate: dayjs(pikadayInput.getAttribute('data-date'), 'DD-MM-YYYY').toDate(),
                setDefaultDate: pikadayInput.getAttribute('data-date') !== "",
                maxDate: dayjs().add(2,'year').endOf('year').subtract(1,'day').toDate(),
                showDaysInNextAndPreviousMonths: true,
                onClose: function () {
                    pikadayInput.blur();
                },
                onSelect: function () {
                    $obj.options.start_date = new Date(dayjs(this.getDate()).toString());
                    $obj.options.end_date = new Date($obj.options.start_date);
                    $obj.options.end_date.setDate($obj.options.end_date.getDate() + $obj.options.timespan - 1);
                    $obj.redraw();
                },
                toString(date) {
                    let inputValue = dayjs($obj.options.start_date)

                    return inputValue.format('D MMM YYYY')
                },
                parse(dateString) {
                    // dateString is the result of `toString` method
                    const parts = dateString.split(' ');
                    const day = parseInt(parts[0], 10);
                    const month = parseInt(parts[1], 10) - 1;
                    const year = parseInt(parts[2], 10);

                    return new Date(year, month, day);
                }
            });
        }
    };


    var jump = function ($obj) {
        var pick_a_date = '<div class="form-group mb-0 position-relative">'
            + '<label for="invoiceName">'
            + $obj._language.check_in
            + '</label>'
            + '<div class="input-wrapper">'
            + '<input id="picker-date-' + $obj.options.element_hack + '" '
            + 'class="form-control bg-white cursor-pointer text-select-none" name="picker-date" type="text" readonly="true" value="" '
            + 'data-date="' + $obj.options.start_date.format("dd-mm-yyyy") + '">'
            + '<span class="input-icon fal fa-calendar-alt"></span></div><div class="grid-picker-container position-absolute" id="' + $obj.options.element_hack + '-container"></div></div>';

        return pick_a_date;
    };

    var redraw_line = function ($obj, unit) {
        var line_div = $("<div></div>").addClass('grid-line mb-2 mb-md-0');
        line_div.attr("id", unit.id);

        var container = $("<div></div>").addClass('font-weight-bold text-truncate font-size-sm');

        if (unit.room_name.length > 30) {
            unit.room_name = unit.room_name.substring(0, 29) + "...";
        }

        container.text(unit.room_name);
        container.attr("title", unit.room_name);

        var subtext = $("<div></div>").addClass('grid-subtext font-size-sm ml-2 ml-md-0 text-right text-md-left');
        subtext.css("min-width", '130px');

        var price_type = unit.getPriceType($obj.options.start_date, true);
        var capacity_text = unit.getCapacity() > 1 ? $obj._language.people_small : $obj._language.person_small;

        subtext.text($obj._language.sleeps_up_to + " " + unit.getCapacity() + " " + capacity_text);

        line_div.append($("<div></div>").addClass('grid-line-room px-0 px-md-2 py-1 py-md-2 d-flex d-md-block align-items-center justify-content-between').append(container).append(subtext));

        var s = new Date($obj.options.start_date);
        var e = new Date($obj.options.end_date);
        const today = new Date();

        e.setDate(e.getDate() + 1);

        if ($obj.options.start_date > today || s.getDate() == today.getDate()) {
            s.setDate(s.getDate() - 1);
            e.setDate(e.getDate() - 1);
        }

        if ($obj.element.classList.contains('vy-grid')) {
            var daysWrapper = $("<div></div>").addClass('grid-days-wrapper d-flex align-items-center rounded-8 border border-light overflow-hidden');
        }

        for (var d = s; d < e; d.setDate(d.getDate() + 1)) {
            var day = create_day($obj, new Date(d), unit);
            if ($obj.element.classList.contains('vy-grid')) {
                daysWrapper.append(day);
            } else {
                line_div.append(day);
            }
        }

        if ($obj.element.classList.contains('vy-grid')) {
            line_div.append(daysWrapper);
        }

        return line_div;
    };

    var create_day = function ($obj, date, unit) {
        if ($obj.element.classList.contains('vy-grid')) {
            var day_div = $("<div></div>").addClass('grid-line-rate h-100').css('width', $obj.styling.rates_width);
        } else {
            var day_div = $("<div></div>").addClass('grid-line-rate p-1 p-md-2').css('width', $obj.styling.rates_width);
        }
        var available = unit.getAvailability(date);
        //day_div.append("<div>" + date + "</div>");
        day_div.addClass(available ? 'grid-available' : 'grid-unavailable');
        day_div.data("year", date.getFullYear()).data("month", date.getMonth()).data("day", date.getDate()).data("room", unit.id);

        if (date.getDay() === 1) {
            day_div.addClass('grid-line-rate-start');
        }

        if (!unit.exact) {
            day_div.addClass('grid-not-exact');
        }

        if (typeof unit.getCapacity() != 'undefined') {
            if (available) {
                var price = unit.getPrice(date);
                var formatted_price = '<div class="font-weight-bolder text-nowrap">R' + (Math.ceil(price).toString()).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + '</div>';
            }

            day_div.append(available ? formatted_price : $obj._language.full);
        }

        var price_type = unit.getPriceType(date, true);

        if (available) {
            var to_add = price_type === "per_unit" ? $obj._language.perunitsmall : $obj._language.pernight;

            if (to_add !== "") {
                day_div.append("<div class='text-nowrap font-size-sm'>" + to_add + "</div>");
                day_div.addClass('has-extra');

                var capacity_info = price_type === "per_unit" ? " " : $obj._language.for + " " + unit.getPricePax(date);
                day_div.append("<div class='text-nowrap font-size-sm'>" + capacity_info + "</div>");
                day_div.addClass('has-extra-info');
            }

            day_div.attr('data-room-id', unit.id);
            day_div.attr('data-room-name', unit.room_name);
            day_div.attr('data-room-sleeps', unit.getPricePax(date, price_type));
            day_div.attr('data-room-type', price_type);
            day_div.attr('data-room-price-breakdown-pax', stringify(unit.getPricePriceBreakdownPax(date)));
            day_div.attr('data-room-estimate', unit.getEstimate(date));
            day_div.attr('data-room-min-stay', unit.getMinStay(date));
        }

        return day_div;
    };

    var create_header = function ($obj) {
        var header_div = $("<div></div>").addClass('grid-header d-flex flex-wrap flex-md-nowrap mb-md-3');

        // Add a placeholder div. (room info) (Padding for date picker)
        header_div.append($("<div></div>").addClass('grid-picker mb-3 mb-md-0').append(jump($obj)));
        var header_dates_div = $("<div></div>").addClass('grid-header-dates d-flex align-items-end rounded-top py-2 py-md-0');
        header_div.append(header_dates_div);

        var first = true;
        var last = 0;

        var s = new Date($obj.options.start_date);
        var e = new Date($obj.options.end_date);
        const today = new Date();

        e.setDate(e.getDate() + 1);

        if ($obj.options.start_date > new Date() || s.getDate() == today.getDate()) {
            s.setDate(s.getDate() - 1);
            e.setDate(e.getDate() - 1);
        }

        for (var d = s; d < e; d.setDate(d.getDate() + 1)) {
            last++;

            if (!first && last !== $obj.options.timespan) {
                var header_html = "<div class='grid-header-date text-center'><div>" + $obj._language.days_short[d.getDay()] + "</div>";
                header_html += "<div class='font-weight-bold'><span class='d-none d-md-inline-block'>" + $obj._language.ordinal(d.getDate()) + "</span><span class='d-md-none'>" + d.getDate() +"</span><span class='ml-1'>" + $obj._language.months_short[d.getMonth()] + "</span></div></div>";
                var header = $("<div></div>").html(header_html).addClass('grid-block').css('width', $obj.styling.rates_width);
            } else if (first) {
                var header_html = '<span class="fa-stack cursor-pointer">'
                    + '<i class="fas fa-circle fa-stack-2x"></i>'
                    + '<i class="fal fa-chevron-circle-left fa-stack-2x fa-inverse"></i>'
                    + '</span>';
                var header = $("<div></div>").html(header_html).addClass('grid-block grid-control grid-control-left justify-content-start justify-content-md-center').css('width', $obj.styling.rates_width);

                if ($obj.options.start_date < new Date()) {
                    header.addClass('grid-disabled');
                }
            } else if (last === $obj.options.timespan) {
                var header_html = '<span class="fa-stack cursor-pointer">'
                    + '<i class="fas fa-circle fa-stack-2x"></i>'
                    + '<i class="fal fa-chevron-circle-right fa-stack-2x fa-inverse"></i>'
                    + '</span>';
                var header = $("<div></div>").html(header_html).addClass('grid-block grid-control grid-control-right justify-content-end justify-content-md-center').css('width', $obj.styling.rates_width);
            }

            header.on('click', function (event) {
                event.preventDefault();
                /* Act on the event */
                if ($(this).hasClass('grid-control-left')) {
                    if ($obj.options.start_date > new Date()) {
                        $obj.previous();
                    }
                } else if ($(this).hasClass('grid-control-right')) {
                    $obj.next();
                }
            });

            header_dates_div.append(header);

            first = false;
        }

        return header_div;
    };

    var preloader = function ($obj, complete) {
        // Merge function used by the preloader
        function merge(set1, set2) {
            for (var key in set2) {
                if (set2.hasOwnProperty(key))
                    set1[key] = set2[key]
            }
            return set1
        }

        var need_to_load = true;
        var want_data_until = new Date($obj.options.end_date);
        want_data_until.setDate(want_data_until.getDate() + 11);

        if (want_data_until > $obj._loaded_until) {
            need_to_load = true;
        } else {
            need_to_load = false;
        }

        if (!($obj.options.start_date.format("yyyy-mm-dd") in $obj.options.units[0].prices)) {
            need_to_load = true;
        }

        let searchStartDate = $obj.options.start_date;
        let tenDaysAgo = new Date(searchStartDate);
        tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);

        let loadDate = new Date(searchStartDate);
        if (tenDaysAgo > new Date()) {
            loadDate = tenDaysAgo;
        }

        // I don't know why we need to do this, but it works so we'll keep it
        loadDate.setMonth(loadDate.getMonth() + 1);
        loadDate.setDate(loadDate.getDate() - 1);

        if (need_to_load && !$obj.options.responsive_redraw) {
            complete();
            const url = "/backend/accommodation/get_rates_grid";

            $.get(url, {
                year:   loadDate.getFullYear(),
                month: loadDate.getMonth(),
                day: loadDate.getDate(),
                rooms: $obj._room_csv,
                pax: $obj.options.adult,
                duration: "50",
                func: 'grid'
            }, function (data) {
                $.each($obj.options.units, function (_key, val) {
                    merge(val.prices, data.unit_details[val.id]);
                });

                $obj._loaded_until = new Date($obj.options.start_date);
                $obj._loaded_until.setDate($obj._loaded_until.getDate() + 50);

                complete();
            }, "json");
        } else {
            complete();
        }
    };

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            new Plugin(this, options);
        });
    }

}(jQuery, window));


var dateFormat = function () {
    var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
        timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
        timezoneClip = /[^-+\dA-Z]/g,
        pad = function (val, len) {
            val = String(val);
            len = len || 2;
            while (val.length < len) val = "0" + val;
            return val;
        };

    // Regexes and supporting functions are cached through closure
    return function (date, mask, utc) {
        var dF = dateFormat;

        // You can't provide utc if you skip other args (use the "UTC:" mask prefix)
        if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
            mask = date;
            date = undefined;
        }

        // Passing date through Date applies Date.parse, if necessary
        date = date ? new Date(date) : new Date;
        if (isNaN(date)) throw SyntaxError("invalid date");

        mask = String(dF.masks[mask] || mask || dF.masks["default"]);

        // Allow setting the utc argument via the mask
        if (mask.slice(0, 4) == "UTC:") {
            mask = mask.slice(4);
            utc = true;
        }

        var _ = utc ? "getUTC" : "get",
            d = date[_ + "Date"](),
            D = date[_ + "Day"](),
            m = date[_ + "Month"](),
            y = date[_ + "FullYear"](),
            H = date[_ + "Hours"](),
            M = date[_ + "Minutes"](),
            s = date[_ + "Seconds"](),
            L = date[_ + "Milliseconds"](),
            o = utc ? 0 : date.getTimezoneOffset(),
            flags = {
                d: d,
                dd: pad(d),
                ddd: dF.i18n.dayNames[D],
                dddd: dF.i18n.dayNames[D + 7],
                m: m + 1,
                mm: pad(m + 1),
                mmm: dF.i18n.monthNames[m],
                mmmm: dF.i18n.monthNames[m + 12],
                yy: String(y).slice(2),
                yyyy: y,
                h: H % 12 || 12,
                hh: pad(H % 12 || 12),
                H: H,
                HH: pad(H),
                M: M,
                MM: pad(M),
                s: s,
                ss: pad(s),
                l: pad(L, 3),
                L: pad(L > 99 ? Math.round(L / 10) : L),
                t: H < 12 ? "a" : "p",
                tt: H < 12 ? "am" : "pm",
                T: H < 12 ? "A" : "P",
                TT: H < 12 ? "AM" : "PM",
                Z: utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
                o: (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),

                S: ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
            };

        return mask.replace(token, function ($0) {
            return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
        });
    };
}();

// Some common format strings
dateFormat.masks = {
    "default": "ddd mmm dd yyyy HH:MM:ss",
    shortDate: "m/d/yy",
    mediumDate: "mmm d, yyyy",
    longDate: "mmmm d, yyyy",
    fullDate: "dddd, mmmm d, yyyy",
    shortTime: "h:MM TT",
    mediumTime: "h:MM:ss TT",
    longTime: "h:MM:ss TT Z",
    isoDate: "yyyy-mm-dd",
    isoTime: "HH:MM:ss",
    isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
    isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
};

// Internationalization strings
dateFormat.i18n = {
    dayNames: [
        "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
        "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    ],
    monthNames: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
        "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
    ]
};


// For convenience.
Date.prototype.format = function (mask, utc) {
    return dateFormat(this, mask, utc);
};
